module.exports = __webpack_public_path__ + "static/media/google.d4e0faaf.svg";